import styled from '@emotion/styled';
import {Stack} from '@travel-frontend/ui-components';

export const Discount = styled(Stack)`
  color: ${({theme}) => theme.colors.borderSelection};
  width: 32px;
  height: 32px;
`;
